export default "__VITE_ASSET__BsIV5IfV__"